var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2999 0.700024L0.699902 5.30002C0.299902 5.70003 0.299902 6.30002 0.699902 6.70002C1.0999 7.10002 1.6999 7.10002 2.0999 6.70002L5.9999 2.80002L9.8999 6.70002C10.2999 7.10002 10.8999 7.10002 11.2999 6.70002C11.6999 6.30002 11.6999 5.70003 11.2999 5.30002L6.6999 0.700024C6.2999 0.300024 5.6999 0.300024 5.2999 0.700024Z",
    fill: "#0C55B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandmore);
export default __webpack_public_path__ + "static/media/expandmore.f8aadc10464fd9933c8bfd5ee57daeb7.svg";
export { ForwardRef as ReactComponent };